/* eslint-disable react-native/no-inline-styles */
import * as React from 'react';
import { Button, Dialog, Portal, Text } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { errorHandler, logoutHandler } from '../services/Utils';
import { hideLogoutAlert } from '../store/customer.slice';
import { hideLoader } from '../store/info.slice';

const LogoutAlert = () => {
  const dispatch = useDispatch();
  const visible = useSelector((state) => state.customer?.show_logout_alert);


  const hideDialog = () => {
    dispatch(hideLogoutAlert());
  };

  const onLogoutHandler = () => {
    hideDialog();
    setTimeout(async () => {
      try {
         logoutHandler();
      } catch (error) {
        console.log(error);
        dispatch(hideLoader());
        errorHandler(error);
      }
    }, 500);
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={hideDialog}>
        <Dialog.Title style={{ fontSize: 16 }}>Logout</Dialog.Title>
        <Dialog.Content>
          <Text variant="labelMedium">Do you wish to log out of your account?</Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={hideDialog}>No</Button>
          <Button onPress={onLogoutHandler}>Yes</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default LogoutAlert;
